/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {GetterTree} from 'vuex';
import {RootState} from '@/store/types';
import {UserSessionStateInterface} from '@/store/modules/user-session/types';

/**
 * The user session module getters provide entry points for stored data.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */

export const getters: GetterTree<UserSessionStateInterface, RootState> = {
    /**
     * Gets the session verifier.
     * @param {UserSessionStateInterface} state
     * @returns {string}
     */
    verifier(state: UserSessionStateInterface): string {
        if (undefined === state.session.verifier || '' === state.session.verifier) {
            return '';
        }
        return state.session.verifier;
    },

    /**
     * Gets the refresh token.
     * @param {UserSessionStateInterface} state
     * @returns {string}
     */
    refreshToken(state: UserSessionStateInterface): string {
        if (undefined === state.session.refresh || '' === state.session.refresh) {
            return '';
        }
        return state.session.refresh;
    },

    /**
     * Gets the session token.
     * @param {UserSessionStateInterface} state
     * @return {string | boolean}
     */
    token(state: UserSessionStateInterface): string|boolean {
        if (undefined === state.session.token || '' === state.session.token) {
            return false;
        }
        return state.session.token;
    },

    /**
     * Gets the session token expiry.
     * @param {UserSessionStateInterface} state
     * @return {number | boolean}
     */
    expiry(state: UserSessionStateInterface): number|boolean {
        if (undefined === state.session.token || '' === state.session.token) {
            return false;
        }
        return state.session.expiry;
    },

    /**
     * Authentication checker.
     *
     * @param {UserSessionStateInterface} state
     *
     * @returns {boolean}
     */
    authenticated(state: UserSessionStateInterface): boolean {
        return '' !== state.session.token && state.session.expiry > (new Date().getDate());
    },
};
